import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { PostsApiService } from '../api/posts.service';

@Injectable({ providedIn: 'root' })
export class MilestoneResolver implements Resolve<any> {

  constructor(
    private apiService: PostsApiService,
  ) { }

  resolve(): Observable<any> {
    return this.apiService.loadMilestones(1);
  }
}

